import {Space} from "antd";
import {OfferingFormCheckoutFormRequiredQuestions} from "./required-questions";
import {OfferingFormCheckoutFormAddedQuestions} from "./added-questions";

export function OfferingFormCheckoutFormWrapper() {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "Flex"}}>
        <div>
          <p>
            Here you can add the question you want your customers to answer during
            checkout. We collect <b>first name</b>, <b>last name</b> and{" "}
            <b>email address</b> by default.
          </p>
        </div>
        <OfferingFormCheckoutFormRequiredQuestions />
        <OfferingFormCheckoutFormAddedQuestions />
      </Space>
    </div>
  );
}
